import { gql } from '@apollo/client';

// ============================================
// Auth Mutations
// ============================================

export const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!, $tenantCode: String!) {
    login(username: $username, password: $password, tenantCode: $tenantCode) {
      accessToken
      refreshToken
      expiresIn
      user {
        employeeId
        username
        ispcode
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout {
      success
      message
    }
  }
`;

export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      expiresIn
      user {
        employeeId
        username
        ispcode
      }
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
      success
      message
    }
  }
`;
